import { FC } from 'react'
import { CategoryBarProps } from './CategoryBar.types'
import { CategoryBarContainer } from './CategoryBar.styles'
import { SegmentLocation } from './segment/Segment.types'
import { Segment } from './segment'

const CategoryBar: FC<CategoryBarProps> = ({ categories }) => {
    const getLocation = (index: number, total: number): SegmentLocation => {
        if (index === 0) {
            return 'start'
        }
        if (index === total - 1) {
            return 'end'
        }
        return 'middle'
    }

    return (
        <CategoryBarContainer data-testid="category-bar">
            {categories.map(({ color, isSelected, text }, index) => (
                <Segment
                    key={`${text}-${index}`}
                    color={color}
                    isSelected={isSelected}
                    text={text}
                    location={getLocation(index, categories.length)}
                />
            ))}
        </CategoryBarContainer>
    )
}

export default CategoryBar
